import { render, staticRenderFns } from "./dealer-detail.vue?vue&type=template&id=6c943505&scoped=true"
import script from "./dealer-detail.vue?vue&type=script&lang=js"
export * from "./dealer-detail.vue?vue&type=script&lang=js"
import style0 from "./dealer-detail.vue?vue&type=style&index=0&id=6c943505&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c943505",
  null
  
)

export default component.exports